import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore } from "@obg/core.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class CurrencyConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCore>) {}

	getCurrenciesEndpoint(): string {
		return this.configService.get((x) => x.core.currency.endpoints!.currencies, "i18n/v1/currencies/");
	}

	getDefaultCurrencyCode(): string {
		return this.configService.get((x) => x.core.currency.defaultCurrencyCode);
	}

	getCurrencyCodesByCountryCode(): Record<string, string> {
		return this.configService.get((x) => x.core.currency.currencyCodesByCountryCode, {});
	}

	getSingleCurrencyCountries(): string[] {
		return this.configService.get((x) => x.core.currency.singleCurrencyCountries, ["se"]);
	}

	getMaskableMarket(): string {
		return this.configService.get((x) => x.core.currency.currencyCodeMask?.market);
	}

	getCurrencyCodeMaskingMap(): Record<string, string> {
		return this.configService.get((x) => x.core.currency.currencyCodeMask?.currencyCodeMaskMap, {});
	}
}
